import React from "react";
import FeatureDocumentation from "../../components/layouts/docsection";
import ProductDashboard from "../../images/ProductsDashboard.png";
import BulkProductUpdate from "../../images/BulkProductUpdate.png";
import InstantDelivery from "../../images/instantDelivery.png";
import AddProduct from "../../images/addProduct.png"
 

const Products = () => {
  const ProductsDoc = {
    title: "Products Inventory",
    description: "Learn how to manage product inventory efficiently.",
    sections: [
      {
        title: "Overview",
        content:
          "The product feature is one of the most important aspects of the dashboard. It helps manage existing products. At a glance, you can see and search through all products, including those in stock, in transit, out of stock, verified, unverified, published, and unpublished.",
        image: ProductDashboard,
        imageAlt: "Product Dashboard Overview",
        imageCaption: "Figure 1: Comprehensive view of the Product Dashboard",
      },
      {
        title: "Bulk Update Products",
        content:
          "To simplify the updating of products, a CSV file of current products is available. Ask your supervisor for this CSV file that must be uploaded to update the data.",
        image: BulkProductUpdate,
        imageAlt: "Bulk Product Update Dashboard Overview",
        imageCaption: "Figure 2: Comprehensive view of the Bulk Product Update Modal",
        subsections: [
          {
            title: "How to Make Bulk Updates",
            content: "The CSV needs to have the following details for a successful update:",
            steps: [
              "SKU - Stock Keeping Unit",
              "Price",
              "Cost Price",
              "Quantity",
              "After carefully reviewing the CSV, upload it and click 'Submit'.",
            ],
          },
        ],
      },
      {
        title: "Instant Delivery",
        content:
          "Certain products have been given delivery priorities and can be updated or removed by inputting their SKUs.",
        image: InstantDelivery,
        imageAlt: "Add Instant Delivery Products",
        imageCaption: "Figure 3: Comprehensive view of add instant delivery product modal",
        subsections: [
          {
            title: "Manage Instant Delivery Updates",
            content: "You can update the delivery status using the product SKU.",
            steps: [
              "Search for the product SKU by entering its name in the search box below.",
              "To update it, simply enter the SKU in the update or remove modal.",
            ],
          },
        ],
      },
      {
        title: "Add Product",
        content: "Products can be added to the shop without variants.",
        image: AddProduct,
        imageAlt: "Add Product Dashboard Overview",
        imageCaption: "Figure 4: Comprehensive view of the Add Product Dashboard",
        subsections: [
          {
            title: "How to Add a Product",
            content: "Product variants refer to the same product but in different sizes, colors, styles, or brands. This is typical for shoes with different sizes or colors.",
            steps: [
              "Product Information: Enter product details like name, selling price, cost price, MOQ, country, and currency. SKUs are automatically generated.",
              "Category and Tags: Select predefined categories and add tags to make products easier to search.",
              "Inventory Management: Add the stock quantity and specify if it is in limited quantity or always available.",
              "Product Variants: Use this for products with different colors, sizes, brands, etc.",
              "Product Media: Upload an image of the product.",
              "Extra Information: Indicate whether the product has instant delivery or normal delivery.",
              "Publish: If you're unsure about publishing a product, you can toggle the draft functionality.",
            ],
          },
        ],
      },
    ],
  };
  
  return <FeatureDocumentation {...ProductsDoc} />;
};

export default Products;
